import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import WabaListView from "@/pages/WhatsApp/WabaListView";
import WabaWizard from "@/pages/WhatsApp/WabaWizard";
import WabaDetailView from "@/pages/WhatsApp/WabaDetailView";
import { Button } from "@/components/ui/button";
import { ProveedorTab } from "@/components/whatsapp/ProveedorTab";
import { NumerosWabaTab } from "@/components/whatsapp/NumerosWabaTab";
import { PruebasTab } from "@/components/whatsapp/PruebasTab";
import { NotificacionesTab } from "@/components/whatsapp/NotificacionesTab";
import HelpTip from "@/components/HelpTip";
import { Plus, MessageCircle, ShieldCheck, Phone, FlaskConical, BellRing, Building2 } from "lucide-react";

const SECTIONS = [
  { id: "cuentas", label: "Cuentas WABA", icon: Building2 },
  { id: "proveedor", label: "Proveedor", icon: ShieldCheck },
  { id: "numeros", label: "Números", icon: Phone },
  { id: "pruebas", label: "Pruebas", icon: FlaskConical },
  { id: "notificaciones", label: "Notificaciones", icon: BellRing },
];

export default function WhatsAppPage() {
  const [params, setParams] = useSearchParams();
  const tab = SECTIONS.some((s) => s.id === params.get("seccion")) ? params.get("seccion") : "cuentas";
  const [wizardOpen, setWizardOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedWaba, setSelectedWaba] = useState(null);

  const setTab = (id) => {
    const next = new URLSearchParams(params);
    if (id === "cuentas") next.delete("seccion");
    else next.set("seccion", id);
    setParams(next, { replace: true });
  };

  if (selectedWaba) {
    return (
      <div className="space-y-6" data-testid="whatsapp-page">
        <WabaDetailView waba={selectedWaba} onBack={() => setSelectedWaba(null)} />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="whatsapp-page">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-xl font-bold text-white flex items-center gap-2" data-testid="whatsapp-page-title">
            <MessageCircle className="w-5 h-5 text-emerald-400" />
            WhatsApp WABA
            <HelpTip
              title="Un solo lugar"
              content="Aquí viven las cuentas, el proveedor, los números, las pruebas y las notificaciones. Ya no se configura WhatsApp dentro de Configuración."
            />
          </h1>
          <p className="text-xs text-muted-foreground mt-1">Cuentas, números, pruebas y avisos al equipo. Todo el WhatsApp del tenant.</p>
        </div>
        {tab === "cuentas" && (
          <Button onClick={() => setWizardOpen(true)} className="gap-2" data-testid="waba-new-account-btn">
            <Plus className="h-4 w-4" />
            Nueva cuenta
          </Button>
        )}
      </div>

      <div className="flex flex-wrap gap-2" data-testid="whatsapp-subtabs-nav">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          const on = tab === s.id;
          return (
            <button
              key={s.id}
              type="button"
              onClick={() => setTab(s.id)}
              className={`px-3 py-2 rounded-xl text-xs border flex items-center gap-1.5 transition ${on ? "border-emerald-500/40 bg-emerald-500/15 text-emerald-300" : "border-white/10 bg-black/20 text-zinc-300 hover:border-white/20"}`}
              data-testid={`whatsapp-subtab-button-${s.id}`}
            >
              <Icon className="w-3.5 h-3.5" />
              {s.label}
            </button>
          );
        })}
      </div>

      <div data-testid={`whatsapp-subtab-content-${tab}`}>
        {tab === "cuentas" && <WabaListView refreshKey={refreshKey} onSelectWaba={setSelectedWaba} />}
        {tab === "proveedor" && <ProveedorTab />}
        {tab === "numeros" && <NumerosWabaTab />}
        {tab === "pruebas" && <PruebasTab />}
        {tab === "notificaciones" && <NotificacionesTab />}
      </div>

      <WabaWizard
        open={wizardOpen}
        onClose={() => setWizardOpen(false)}
        onSuccess={() => setRefreshKey((k) => k + 1)}
      />
    </div>
  );
}
